/**
* O componente recebe as variáveis explicadas abaixo
*
* @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
* @param {Object} params  - Parâmetros para serem utilizados
*/

const $el = $(el);
const $form       = $el.find('#formContact');
const $birthdate  = $form.find('[name="birth_date"]');
const $cpf        = $form.find('[name="cpf"]');
const $cellphone  = $form.find('[name="phone"]');
const $checks     = $form.find('[name="segments[]"]');
const $btRegister = $form.find('[type="submit"]');
const $firstStep  = $el.find('.first-step');
const $successful = $el.find('.successful');
const $requireds  = $form.find('[required]');

const btn  = $btRegister[0];

const isPt = document.documentElement.lang == 'pt';

function countFalseInObject(obj) {
    let count = 0;

    for (const key in obj) {
      if (obj[key] === false) {
        count++;
      }
    }

    return count;
}

const SPMaskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
},
spOptions = {
    onKeyPress: function(val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
    }
};

$.validator.addMethod("datebr", function(value, element) {
        var check = false;
        var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
        if( re.test(value)){
            var adata = value.split('/');
            var gg = parseInt(adata[0],10);
            var mm = parseInt(adata[1],10);
            var aaaa = parseInt(adata[2],10);
            var xdata = new Date(aaaa,mm-1,gg);
            if ( ( xdata.getFullYear() == aaaa ) && ( xdata.getMonth () == mm - 1 ) && ( xdata.getDate() == gg ) )
            check = true;
            else
            check = false;
        } else
        check = false;
        return this.optional(element) || check;
    },
    "Insira uma data válida"
);

$.validator.addMethod('cellphone', function (value, element) {
    value = value.replace("(","");
    value = value.replace(")", "");
    value = value.replace("-", "");
    value = value.replace(" ", "").trim();

    if (value == '0000000000') {
        return (this.optional(element) || false);
    } else if (value == '00000000000') {
        return (this.optional(element) || false);
    }

    if (["00", "01", "02", "03", , "04", , "05", , "06", , "07", , "08", "09", "10"]
    .indexOf(value.substring(0, 2)) != -1) {
        return (this.optional(element) || false);
    }
    if (value.length < 10 || value.length > 11) {
        return (this.optional(element) || false);
    }
    if (["6", "7", "8", "9"].indexOf(value.substring(2, 3)) == -1) {
        return (this.optional(element) || false);
    }
    return (this.optional(element) || true);
}, 'Informe um número de telefone celular válido!');

function handleValidation() {
    const formInvalidsNumber = countFalseInObject(formValidate.invalid);
    const formRequiredNumber = $requireds.length;

    let hasError = true;
    $checks.each(function() {
        if($(this).is(':checked')) {
            hasError = false;
        }
    });

    if(formInvalidsNumber == formRequiredNumber && hasError == false) {
        $btRegister.removeAttr('disabled');
    } else {
        $btRegister.attr('disabled', true);
    }
}

const formValidate = $form.validate({
    highlight: function(element, errorClass, validClass) {
        const $elm = $(element).parents('.box-input');

        $elm.addClass(errorClass).removeClass(validClass);

        return false;
    },
    unhighlight: function(element, errorClass, validClass) {
        const $elm = $(element).parents('.box-input');

        $elm.removeClass(errorClass).addClass(validClass);

        return false;
    },
    errorPlacement: function(error, element) {
        return false
    },
    success: function(label) {
        handleValidation();
    },
    rules: {
        birthdate: {
            required: true,
            datebr: true
        },
        email: {
            required: true,
            email: true
        },
        confirmEmail: {
            required: true,
            email: true,
            equalTo: "#email"
        },
        cpf: {
            required: true,
            cpfBR: (isPt) ? true : false
        },
        cellphone: {
            required: true,
            cellphone: true
        },
    },
    submitHandler: function(form) {
        const formData = $(form).serialize();
        btn.classList.add('sending');
        btn.disabled = true;

        $.post(window.location.href, formData, function(response) {
            Navigation.helpers.scrollTo(0);

            $firstStep.hide();
            $successful.show();
            btn.classList.remove('sending');
            btn.disabled = false;
            form.reset();

            const category = 'Seja_nosso_cliente';
            const action   = 'cliente_cadastrado';

            $document.trigger('remoteTrack', [category, action]);
        }, 'json').fail(function(response) {
            let message = '';

            if(response.responseJSON.errors.name) {
                message += 'Erro nome: '+response.responseJSON.errors.name[0]+"\r\n";
            }
            if(response.responseJSON.errors.birth_date) {
                message += 'Erro data de nascimento: '+response.responseJSON.errors.birth_date[0]+"\r\n";
            }
            if(response.responseJSON.errors.cpf) {
                message += 'Erro CPF: '+response.responseJSON.errors.cpf[0]+"\r\n";
            }
            if(response.responseJSON.errors.phone) {
                message += 'Erro telefone: '+response.responseJSON.errors.phone[0]+"\r\n";
            }
            if(response.responseJSON.errors.email) {
                message += 'Erro e-mail: '+response.responseJSON.errors.email[0]+"\r\n";
            }
            if(response.responseJSON.errors.segments) {
                $checks.addClass('error');
            }

            btn.classList.remove('sending');
            btn.disabled = false;
        });
    }
});

$checks.on('click', function() {
    handleValidation();
});

$requireds.on("change", function() {
    handleValidation();
});

if(isPt) {
    $cellphone.mask(SPMaskBehavior, spOptions);
    $cpf.mask('000.000.000-00', {reverse: true});
} else {
    $cpf.mask('99-9999999');
}

$birthdate.mask('00/00/0000');
